import React from 'react'
import { Redirect } from 'react-router-dom'
import { observer } from 'mobx-react-lite'

import { useStore } from '../../../hooks/storeHook'
import { getFirstMpCardAccountUrl, mpCardRoutes } from '../../../common/mpCardRoutes'

export const MpCardRootRedirect =
  observer(() => {
    const {syncStore} = useStore()
    const firstAccountUrl = getFirstMpCardAccountUrl(syncStore)

    return <Redirect to={firstAccountUrl ?? mpCardRoutes.main.template}/>
  })
